import { render, staticRenderFns } from "./EditTireTypeModal.vue?vue&type=template&id=47296c34&scoped=true&"
import script from "./EditTireTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditTireTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTireTypeModal.vue?vue&type=style&index=0&id=47296c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47296c34",
  null
  
)

export default component.exports